import React from 'react';

const Hotels = () => {
    return(
        <>
        <h2>Welcome to Broshall Hotels GB</h2>
        </>
    )
}

export default Hotels;